<p-toast></p-toast>

<div class="checkout-page">
  <div class="thankyou-page">
    <h2>Thank you for Shopping with Us!</h2>
    <h3>We have received your order and it will be delivered in next 3 days</h3>
    <p-button label="Back to shop" routerLink="/"></p-button>
  </div>
</div>
